export default __webpack_public_path__ + "static/media/warmmetabolismdrink@3x.f7265847.jpg";